import { detectPlatform } from "./detect"
import type { VoiceRecorder } from "./voice-recorder.base"
import { createNativeRecorder } from "./voice-recorder.native"
import { createWebRecorder } from "./voice-recorder.web"

export {
	RecorderError,
	type RecorderPermission,
	type RecorderResult,
	type VoiceRecorder,
} from "./voice-recorder.base"
export { releaseMicStream } from "./voice-recorder.mic-stream"

export function createVoiceRecorder(): VoiceRecorder {
	switch (detectPlatform()) {
		case "android":
		case "ios":
			return createNativeRecorder()
		case "telegram":
		case "browser":
			return createWebRecorder()
	}
}
